import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';


import { PurchaseReturnService, CommonService, SubscribeService } from '../../../services/index';
import { PurchaseReturnModel } from '../../../model/index';
//import { clientOutComponent } from '../../common/clientOut.component';

@Component({
    selector: 'purchase-return-tab',
    templateUrl: './purchaseReturn.component.html'
})
export class PurchaseReturnComponent implements OnInit {

    isLoadMask: Promise<any>;
    serviceWalkInData: PurchaseReturnModel[];
    loadingIndicator: boolean = true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'return_id',
        orderDir: 'asc'
    };
    filterData = {
        "search_name": "",
        "from_date":new Date(),
        "to_date":new Date()
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
  
    columns = [];
    toggleCol = [];
    
    scrollTimeout: any;
    suppressPaging: boolean = false;
    constructor(public toasterService: ToasterService, 
         private purchaseReturnService: PurchaseReturnService,
         public subscribeService: SubscribeService, 
         private modalService: BsModalService)
    {
       
    }

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellClass: 'cell-center', cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Return No', prop: 'auto_no', width: 110,minWidth: 110, maxWidth: 110, toggle: true },
            { name: 'Return Date', prop: 'date', width: 120,minWidth: 120, maxWidth: 120, toggle: true },
            { name: 'Purchase No', prop: 'purchase_no', width: 120,minWidth: 120, maxWidth: 120 },
            { name: 'Purchase Date', prop: 'disp_date', width: 130, minWidth: 130,maxWidth: 130 },
            { name: 'Party Name', prop: 'party_name', width: 120,minWidth: 120, maxWidth: 120 },
            { name: 'Quantity', prop: 'total_qty', width: 120,minWidth: 120, maxWidth: 120 },
            { name: 'Amount', prop: 'amount', width: 120,minWidth: 120, maxWidth: 120 },
            { name: 'Action', prop: 'action', width: 110,minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];



        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });

        this.subscribeService.publishReloadClientWalkInGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });

        this.subscribeService.publishReloadServiceGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        })
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterTextBox').focus();
        }, 100);

    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getPurchaseReturnList();
    }

    onColumnToggle(colToShow) {
        console.log(colToShow);
        this.columns = colToShow;
    }


    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getPurchaseReturnList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 1000)
    }
    clearFilter(): void {
        this.filterData = {
            "search_name": "",
            "from_date": new Date(),
            "to_date": new Date()
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getPurchaseReturnList();
    }
    getPurchaseReturnList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            search_name: this.filterData['search_name'],
            from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            from_page: this['params']['tabParams']
        };
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllSku(params));
        this.isLoadMask = this.purchaseReturnService
            .getPurchaseReturnList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.serviceWalkInData = res.data;
            });
    }

    addEditPurchaseReturn(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'return_id': '',
                mode: mode
            };
        } else if (mode != "Add") {
            row['mode'] = mode;
        }

        that.subscribeService.subScribeTabID('Transaction', 'AddPurchaseReturnComponent', Object.assign({}, row), this['params']['tabParams']);

    }


    deletePurchaseReturn(row: any): void {

        let that = this,
            data = {
                return_id: row.return_id,
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Purchase Return Details of [' + row['auto_no'] + '-' + row['party_name'] + ']',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.purchaseReturnService
                .deletePurchaseReturn(data)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getPurchaseReturnList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {

        })
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/purchaseReturn/purchaseReturn.component.ts